module.exports = __webpack_public_path__ + "static/media/iconFinancial.3af5e820.svg";